import Image from "next/image";
import { useTranslation } from "next-i18next";
import PricingCardComponent from "./PriceCardComponent";

const PricesComponent = () => {
    const { t } = useTranslation("common"); // 'common' is the namespace

    return (
        <div className="w-full text-[1em] mt-[5em] mb-[2em]">
            <div className="flex items-center justify-center ">
                <div className="text-primary  px-2 text-[0.5em] md:text-[0.8em]">
                    <div className="text-center font-bold text-primary my-[0.2em] text-[3.5em]">
                        {t("home.pricing.1.subtitle")}
                    </div>
                    <p className="text-center text-[2em] font-thin w-[40em] md:w-[40em] text-[#737373] mx-auto">
                        {t("home.pricing.1.desc")}
                    </p>
                </div>
            </div>
            <div className="flex  items-center justify-center w-full text-[0.4em] mt-[10em] ">
                <div className="grid gap-[5em]  md:gap-[10em] grid-cols-2 md:grid-cols-3 px-[4em] w-full md:w-[80%] ">
                    <div
                        data-aos="flip-left"
                        className="col-span-2 md:col-span-1"
                    >
                        <PricingCardComponent
                            transIndex={"1"}
                            className="!bg-[#F7F7FA] text-primary child:!text-black rounded-[2em] [&_button]:hover:w-full [&_button]:bg-[#E8E8F1] [&_button]:text-primary [&_button]:hover:h-[10em] [&_button]:hover:text-white "
                        />
                    </div>
                    <div data-aos="flip-right">
                        <PricingCardComponent
                            transIndex={"2"}
                            className="!bg-primary [&_.quota]:text-secondary  text-[white] top-anim rounded-[2em] [&_button]:hover:w-full [&_button]:bg-[#FAA330] [&_button]:text-[white] [&_button]:hover:h-[10em] [&_button]:hover:text-white"
                        />
                    </div>
                    <div data-aos="flip-left">
                        <PricingCardComponent
                            transIndex={"3"}
                            className="!bg-[#F7F7FA] text-primary child:!text-black bottom-anim rounded-[2em] [&_button]:hover:w-full [&_button]:bg-[#E8E8F1] [&_button]:text-primary [&_button]:hover:h-[10em] [&_button]:hover:text-white"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PricesComponent;
